import registrationStep from "../../registrationStep";
import RangeRules from "./RangeRules";

export default registrationStep(RangeRules, "range-rules", "agreement");



// WEBPACK FOOTER //
// ./src/registration/components/RangeRules/index.js